export default ($http, $parse) => ({
    restrict: 'EA',
    scope: false,
    link($scope, $element, attrs) {
        var onTextReady = attrs.onTextReady && $parse(attrs.onTextReady);
        var isReading = attrs.isReading && $parse(attrs.isReading);

        if (isReading) isReading.assign($scope, true);
        $http.get(attrs.httpReader || attrs.src || attrs.href || attrs.url).then((res) => {
            console.info('httpReader.done', res);
            if (onTextReady) onTextReady($scope, { $response: res });
            if (isReading) isReading.assign($scope, false);
        });
    } //link
});